import { ObjectUpdate } from '../../../concepts/objects';
import { ColorGroup } from '../../../ui';
import { CreatePhysicalToolBehavior } from '../../canvas/tooling/CreatePhysicalToolBehavior';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Topic } from './Topic';

class CreateTopicToolBehavior extends CreatePhysicalToolBehavior(Topic) {

    protected createSubject(u: ObjectUpdate) {
        const topic = super.createSubject(u);
        topic.color = this.settings.color ?? ColorGroup.default[2];
        // TopicSuspendedAttr.set(topic, true);
        return topic;
    }

    protected shouldForceSnap(): boolean {
        return false;
    }

    // protected updateSubject(topic: Topic) {

    //     const bounds = topic.bounds(RelativeTo.Model).inflate([150, 150]);
    //     const candidates = this.explore(topic);

    //     const boundary = Topic.computeBoundary(topic, candidates);
    //     TopicBoundaryAttr.set(topic, boundary);
    // }

    // protected finalizeSubject(topic: Topic) {
    //     TopicSuspendedAttr.set(topic, false);
    // }
}

export const topicTool = defineToolWithCommonBehaviors({
    id: 'topicTool',
    label: 'Topics',
    category: 'collaboration',
    icon: 'deqo://icons/deqo/group',
    weight: 1030,
    shortcut: 'G',
    behaviors: [
        CreateTopicToolBehavior,
    ]
});
